/**
 * Shared layout for SkillsSheet, AddSkillsSheet, and AddTaskSheet:
 * px-6 from sheet edge to content; body scrolls inside SheetContent’s flex-1 region.
 */
export const skillPanelSheetHeaderClass = 'px-6 pt-6 pb-0 gap-1.5';

export const skillPanelSheetTitleClass
    = 'type-subheading-medium text-secondary-foreground light:text-foreground dark:text-white';

export const skillPanelSheetDescriptionClass
    = 'type-caption text-white/85 light:text-foreground dark:text-foreground';

/** Direct child of the sheet scroll area (overflow-y-auto on SheetContent). */
export const skillPanelSheetBodyClass
    = 'flex w-full flex-col px-6 pb-6 text-white light:text-foreground dark:text-white';

export const skillPanelSheetFooterClass
    = 'mt-0 flex flex-row justify-between gap-2 px-6 pb-6 pt-2 sm:justify-between';
